export const convertRalToRgb = (value) => {
  if (!value) {
    console.error("No RAL code was provided");
    return;
  }
  if (!(value in ralToRgb)) {
    console.error("invalid RAL color was provided");
    return;
  }
  return ralToRgb[value] || null;
};

const ralToRgb = {
  "RAL 0000": "rgb( 255 , 255 , 255 )",
  "RAL 1000": "rgb( 204 , 197 , 143 )",
  "RAL 1001": "rgb( 209 , 188 , 138 )",
  "RAL 1002": "rgb( 210 , 183 , 115 )",
  "RAL 1003": "rgb( 247 , 186 , 11 )",
  "RAL 1004": "rgb( 226 , 176 , 7 )",
  "RAL 1005": "rgb( 200 , 159 , 4 )",
  "RAL 1006": "rgb( 225 , 161 , 0 )",
  "RAL 1007": "rgb( 231 , 156 , 0 )",
  "RAL 1011": "rgb( 175 , 138 , 84 )",
  "RAL 1012": "rgb( 217 , 192 , 34 )",
  "RAL 1013": "rgb( 233 , 229 , 206 )",
  "RAL 1014": "rgb( 222 , 208 , 159 )",
  "RAL 1015": "rgb( 234 , 222 , 189 )",
  "RAL 1016": "rgb( 234 , 240 , 68 )",
  "RAL 1017": "rgb( 244 , 183 , 82 )",
  "RAL 1018": "rgb( 243 , 224 , 59 )",
  "RAL 1019": "rgb( 164 , 149 , 125 )",
  "RAL 1020": "rgb( 154 , 148 , 100 )",
  "RAL 1021": "rgb( 238 , 201 , 0 )",
  "RAL 1023": "rgb( 240 , 202 , 0 )",
  "RAL 1024": "rgb( 184 , 156 , 80 )",
  "RAL 1026": "rgb( 245 , 255 , 0 )",
  "RAL 1027": "rgb( 163 , 140 , 21 )",
  "RAL 1028": "rgb( 255 , 171 , 0 )",
  "RAL 1032": "rgb( 221 , 178 , 15 )",
  "RAL 1033": "rgb( 250 , 171 , 33 )",
  "RAL 1034": "rgb( 237 , 171 , 86 )",
  "RAL 1035": "rgb( 162 , 153 , 133 )",
  "RAL 1036": "rgb( 146 , 117 , 73 )",
  "RAL 1037": "rgb( 238 , 162 , 5 )",
  "RAL 2000": "rgb( 221 , 121 , 7 )",
  "RAL 2001": "rgb( 190 , 78 , 36 )",
  "RAL 2002": "rgb( 198 , 57 , 39 )",
  "RAL 2003": "rgb( 250 , 132 , 43 )",
  "RAL 2004": "rgb( 231 , 91 , 18 )",
  "RAL 2005": "rgb( 255 , 35 , 0 )",
  "RAL 2007": "rgb( 255 , 164 , 33 )",
  "RAL 2008": "rgb( 243 , 117 , 44 )",
  "RAL 2009": "rgb( 225 , 85 , 1 )",
  "RAL 2010": "rgb( 212 , 101 , 47 )",
  "RAL 2011": "rgb( 236 , 124 , 37 )",
  "RAL 2012": "rgb( 219 , 106 , 80 )",
  "RAL 2013": "rgb( 149 , 69 , 39 )",
  "RAL 3000": "rgb( 171 , 37 , 36 )",
  "RAL 3001": "rgb( 160 , 33 , 40 )",
  "RAL 3002": "rgb( 161 , 35 , 43 )",
  "RAL 3003": "rgb( 141 , 29 , 44 )",
  "RAL 3004": "rgb( 112 , 31 , 41 )",
  "RAL 3005": "rgb( 94 , 32 , 40 )",
  "RAL 3007": "rgb( 64 , 34 , 37 )",
  "RAL 3009": "rgb( 112 , 55 , 49 )",
  "RAL 3011": "rgb( 126 , 41 , 44 )",
  "RAL 3012": "rgb( 203 , 141 , 115 )",
  "RAL 3013": "rgb( 156 , 50 , 46 )",
  "RAL 3014": "rgb( 212 , 116 , 121 )",
  "RAL 3015": "rgb( 225 , 166 , 173 )",
  "RAL 3016": "rgb( 172 , 64 , 52 )",
  "RAL 3017": "rgb( 211 , 84 , 95 )",
  "RAL 3018": "rgb( 209 , 65 , 82 )",
  "RAL 3020": "rgb( 193 , 18 , 28 )",
  "RAL 3022": "rgb( 213 , 109 , 86 )",
  "RAL 3024": "rgb( 247 , 0 , 0 )",
  "RAL 3026": "rgb( 255 , 0 , 0 )",
  "RAL 3027": "rgb( 180 , 32 , 65 )",
  "RAL 3031": "rgb( 172 , 50 , 59 )",
  "RAL 3032": "rgb( 113 , 21 , 33 )",
  "RAL 3033": "rgb( 178 , 76 , 67 )",
  "RAL 4001": "rgb( 138 , 90 , 131 )",
  "RAL 4002": "rgb( 147 , 61 , 80 )",
  "RAL 4003": "rgb( 209 , 91 , 143 )",
  "RAL 4004": "rgb( 105 , 22 , 57 )",
  "RAL 4005": "rgb( 131 , 99 , 157 )",
  "RAL 4006": "rgb( 153 , 37 , 114 )",
  "RAL 4007": "rgb( 74 , 32 , 59 )",
  "RAL 4008": "rgb( 144 , 70 , 132 )",
  "RAL 4009": "rgb( 163 , 137 , 149 )",
  "RAL 4010": "rgb( 198 , 54 , 120 )",
  "RAL 4011": "rgb( 135 , 115 , 161 )",
  "RAL 4012": "rgb( 107 , 104 , 128 )",
  "RAL 5000": "rgb( 56 , 76 , 112 )",
  "RAL 5001": "rgb( 31 , 71 , 100 )",
  "RAL 5002": "rgb( 43 , 44 , 124 )",
  "RAL 5003": "rgb( 42 , 55 , 86 )",
  "RAL 5004": "rgb( 29 , 31 , 42 )",
  "RAL 5005": "rgb( 21 , 72 , 137 )",
  "RAL 5007": "rgb( 65 , 103 , 141 )",
  "RAL 5008": "rgb( 49 , 60 , 72 )",
  "RAL 5009": "rgb( 46 , 89 , 120 )",
  "RAL 5010": "rgb( 19 , 68 , 124 )",
  "RAL 5011": "rgb( 35 , 44 , 63 )",
  "RAL 5012": "rgb( 52 , 129 , 184 )",
  "RAL 5013": "rgb( 35 , 45 , 83 )",
  "RAL 5014": "rgb( 108 , 124 , 152 )",
  "RAL 5015": "rgb( 40 , 116 , 178 )",
  "RAL 5017": "rgb( 14 , 81 , 141 )",
  "RAL 5018": "rgb( 33 , 136 , 143 )",
  "RAL 5019": "rgb( 26 , 87 , 132 )",
  "RAL 5020": "rgb( 11 , 65 , 81 )",
  "RAL 5021": "rgb( 7 , 115 , 122 )",
  "RAL 5022": "rgb( 47 , 42 , 90 )",
  "RAL 5023": "rgb( 77 , 102 , 142 )",
  "RAL 5024": "rgb( 106 , 147 , 176 )",
  "RAL 5025": "rgb( 41 , 100 , 120 )",
  "RAL 5026": "rgb( 16 , 44 , 84 )",
  "RAL 6000": "rgb( 50 , 118 , 98 )",
  "RAL 6001": "rgb( 40 , 113 , 62 )",
  "RAL 6002": "rgb( 39 , 98 , 53 )",
  "RAL 6003": "rgb( 75 , 87 , 62 )",
  "RAL 6004": "rgb( 14 , 66 , 67 )",
  "RAL 6005": "rgb( 15 , 67 , 54 )",
  "RAL 6006": "rgb( 64 , 67 , 59 )",
  "RAL 6007": "rgb( 40 , 52 , 36 )",
  "RAL 6008": "rgb( 53 , 56 , 46 )",
  "RAL 6009": "rgb( 38 , 57 , 47 )",
  "RAL 6010": "rgb( 62 , 117 , 59 )",
  "RAL 6011": "rgb( 102 , 130 , 91 )",
  "RAL 6012": "rgb( 49 , 64 , 61 )",
  "RAL 6013": "rgb( 121 , 124 , 90 )",
  "RAL 6014": "rgb( 68 , 67 , 55 )",
  "RAL 6015": "rgb( 61 , 64 , 58 )",
  "RAL 6016": "rgb( 2 , 106 , 82 )",
  "RAL 6017": "rgb( 70 , 134 , 65 )",
  "RAL 6018": "rgb( 72 , 164 , 63 )",
  "RAL 6019": "rgb( 183 , 217 , 177 )",
  "RAL 6020": "rgb( 53 , 71 , 51 )",
  "RAL 6021": "rgb( 134 , 164 , 124 )",
  "RAL 6022": "rgb( 62 , 60 , 50 )",
  "RAL 6024": "rgb( 0 , 135 , 84 )",
  "RAL 6025": "rgb( 83 , 117 , 60 )",
  "RAL 6026": "rgb( 0 , 93 , 82 )",
  "RAL 6027": "rgb( 129 , 192 , 187 )",
  "RAL 6028": "rgb( 45 , 85 , 70 )",
  "RAL 6029": "rgb( 0 , 114 , 67 )",
  "RAL 6032": "rgb( 15 , 133 , 88 )",
  "RAL 6033": "rgb( 71 , 138 , 132 )",
  "RAL 6034": "rgb( 127 , 176 , 178 )",
  "RAL 6035": "rgb( 27 , 84 , 44 )",
  "RAL 6036": "rgb( 0 , 93 , 76 )",
  "RAL 7000": "rgb( 126 , 139 , 146 )",
  "RAL 7001": "rgb( 143 , 153 , 159 )",
  "RAL 7002": "rgb( 129 , 127 , 104 )",
  "RAL 7003": "rgb( 122 , 123 , 109 )",
  "RAL 7004": "rgb( 158 , 160 , 161 )",
  "RAL 7005": "rgb( 107 , 113 , 111 )",
  "RAL 7006": "rgb( 117 , 111 , 97 )",
  "RAL 7008": "rgb( 116 , 102 , 67 )",
  "RAL 7009": "rgb( 91 , 98 , 89 )",
  "RAL 7010": "rgb( 87 , 93 , 87 )",
  "RAL 7011": "rgb( 85 , 93 , 97 )",
  "RAL 7012": "rgb( 89 , 97 , 99 )",
  "RAL 7013": "rgb( 85 , 85 , 72 )",
  "RAL 7015": "rgb( 81 , 86 , 92 )",
  "RAL 7016": "rgb( 55 , 63 , 67 )",
  "RAL 7021": "rgb( 46 , 50 , 52 )",
  "RAL 7022": "rgb( 75 , 77 , 70 )",
  "RAL 7023": "rgb( 129 , 132 , 121 )",
  "RAL 7024": "rgb( 71 , 74 , 80 )",
  "RAL 7026": "rgb( 55 , 68 , 71 )",
  "RAL 7030": "rgb( 147 , 147 , 136 )",
  "RAL 7031": "rgb( 93 , 105 , 112 )",
  "RAL 7032": "rgb( 185 , 185 , 168 )",
  "RAL 7033": "rgb( 129 , 137 , 121 )",
  "RAL 7034": "rgb( 147 , 145 , 118 )",
  "RAL 7035": "rgb( 203 , 208 , 204 )",
  "RAL 7036": "rgb( 154 , 150 , 151 )",
  "RAL 7037": "rgb( 124 , 127 , 126 )",
  "RAL 7038": "rgb( 180 , 184 , 176 )",
  "RAL 7039": "rgb( 107 , 105 , 95 )",
  "RAL 7040": "rgb( 157 , 163 , 166 )",
  "RAL 7042": "rgb( 143 , 150 , 149 )",
  "RAL 7043": "rgb( 78 , 84 , 81 )",
  "RAL 7044": "rgb( 189 , 189 , 178 )",
  "RAL 7045": "rgb( 145 , 150 , 154 )",
  "RAL 7046": "rgb( 130 , 137 , 142 )",
  "RAL 7047": "rgb( 207 , 208 , 207 )",
  "RAL 7048": "rgb( 136 , 129 , 117 )",
  "RAL 8000": "rgb( 136 , 113 , 66 )",
  "RAL 8001": "rgb( 156 , 107 , 48 )",
  "RAL 8002": "rgb( 123 , 81 , 65 )",
  "RAL 8003": "rgb( 128 , 84 , 47 )",
  "RAL 8004": "rgb( 143 , 78 , 53 )",
  "RAL 8007": "rgb( 111 , 74 , 47 )",
  "RAL 8008": "rgb( 111 , 79 , 40 )",
  "RAL 8011": "rgb( 90 , 58 , 41 )",
  "RAL 8012": "rgb( 103 , 56 , 49 )",
  "RAL 8014": "rgb( 73 , 57 , 45 )",
  "RAL 8015": "rgb( 99 , 58 , 52 )",
  "RAL 8016": "rgb( 76 , 47 , 38 )",
  "RAL 8017": "rgb( 68 , 50 , 45 )",
  "RAL 8019": "rgb( 63 , 58 , 58 )",
  "RAL 8022": "rgb( 33 , 31 , 32 )",
  "RAL 8023": "rgb( 166 , 94 , 47 )",
  "RAL 8024": "rgb( 121 , 85 , 60 )",
  "RAL 8025": "rgb( 117 , 92 , 73 )",
  "RAL 8028": "rgb( 78 , 59 , 43 )",
  "RAL 8029": "rgb( 119 , 60 , 39 )",
  "RAL 9001": "rgb( 239 , 235 , 220 )",
  "RAL 9002": "rgb( 221 , 222 , 212 )",
  "RAL 9003": "rgb( 244 , 248 , 244 )",
  "RAL 9004": "rgb( 46 , 48 , 50 )",
  "RAL 9005": "rgb( 10 , 10 , 13 )",
  "RAL 9006": "rgb( 165 , 168 , 166 )",
  "RAL 9007": "rgb( 143 , 143 , 140 )",
  "RAL 9010": "rgb( 247 , 249 , 239 )",
  "RAL 9011": "rgb( 41 , 44 , 47 )",
  "RAL 9016": "rgb( 247 , 251 , 245 )",
  "RAL 9017": "rgb( 42 , 45 , 47 )",
  "RAL 9018": "rgb( 207 , 211 , 205 )",
  "RAL 9022": "rgb( 156 , 156 , 156 )",
  "RAL 9023": "rgb( 126 , 129 , 130 )",
};
